import {loadLibrary} from './Util';
import {LIB_URL} from '../App';


if ($('.js-other-news-slider,.js-slider-articles-3').length) {
    loadLibrary(LIB_URL.SWIPER, () => {
        $('.js-other-news-slider').each(function(index) {
            const $slider = $(this);
            const slidesCount = $slider.find('.swiper-slide').length;

            $slider.parents('.slider-other-news').find('.js-other-news-slider-prev-btn').addClass('js-other-prev'+index);
            $slider.parents('.slider-other-news').find('.js-other-news-slider-next-btn').addClass('js-other-next'+index);
            $slider.parents('.slider-other-news').find('.js-other-news-slider-pagination').addClass('js-other-pagination'+index);

            let sliderLoop = !$(this).is('[data-noloop]');
            let dynamicBulletsBool = false;
            if (App.H.hasClass('page-constructor')) {
                sliderLoop = false;
                dynamicBulletsBool = true;
            }
            const options = {
                loop: sliderLoop,
                slidesPerView: 1,
                navigation: {
                    prevEl: '.js-other-prev' + index,
                    nextEl: '.js-other-next' + index,
                },
                breakpoints: {
                    768: {
                        /*spaceBetween: 10,*/
                        slidesPerGroup: 2,
                        slidesPerView: 2
                    },
                    1200: {
                        slidesPerGroup: 2,
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    1600: {
                        slidesPerGroup: 2,
                        slidesPerView: 2,
                        spaceBetween: 250
                    }
                },
                /*loop: true,*/
                pagination: {
                    el: '.js-other-pagination'+index,
                    bulletClass: `slider-other-news__pagination-item`,
                    bulletActiveClass: `slider-other-news__pagination-item--active`,
                    clickable: true,
                    dynamicBullets: dynamicBulletsBool,
                }
            };
            let slidesPerView = getSlidesPerView(options);

            if (slidesPerView == 'auto' || slidesPerView < slidesCount) {
                /*Swiper.use([Pagination, Navigation]);*/
                new Swiper(this, options);
            } else {
                $slider.parent().addClass('_controls-off');
            }
        });

        $('.js-slider-articles-3').each(function(index) {
            const autoHeightBool = $(this).is('[data-autoheight]');
            const $slider = $(this);
            const slidesCount = $slider.find('.swiper-slide').length;
            // Путаница с классами навигации. Есть блоки с навигацией js-slider-articles-, есть блоки с js-other-news-slider-.
            // Поэтому даем им одинаковые классы js- и указываем в качестве навигации их.
            $slider.parents('.slider-other-news').find('.js-slider-articles-prev-btn').addClass('js-other3-prev'+index);
            $slider.parents('.slider-other-news').find('.js-slider-articles-next-btn').addClass('js-other3-next'+index);
            $slider.parents('.slider-other-news').find('.js-slider-articles-pagination').addClass('js-other3-pagination'+index);
            $slider.parents('.slider-other-news').find('.js-other-news-slider-prev-btn').addClass('js-other3-prev'+index);
            $slider.parents('.slider-other-news').find('.js-other-news-slider-next-btn').addClass('js-other3-next'+index);
            $slider.parents('.slider-other-news').find('.js-other-news-slider-pagination').addClass('js-other3-pagination'+index);

            let sliderLoop = !$(this).is('[data-noloop]');
            let dynamicBulletsBool = false;
            if (App.H.hasClass('page-constructor')) {
                sliderLoop = false;
                dynamicBulletsBool = true;
            }

            const options = {
                loop: sliderLoop,
                slidesPerView: 1,
                autoHeight: autoHeightBool,
                navigation: {
                    prevEl: '.js-other3-prev' + index,
                    nextEl: '.js-other3-next' + index,
                },
                breakpoints: {
                    768: {
                        /*spaceBetween: 10,*/
                        allowTouchMove: true,
                        keyboard: true,
                        slidesPerGroup: 2,
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    1280: {
                        allowTouchMove: slidesCount > 3,
                        keyboard: slidesCount > 3,
                        slidesPerGroup: 3,
                        slidesPerView: 3,
                        spaceBetween: 30,
                    }
                },
                pagination: {
                    el: '.js-other3-pagination'+index,
                    dynamicBullets: dynamicBulletsBool,
                    bulletClass: `slider-other-news__pagination-item`,
                    bulletActiveClass: `slider-other-news__pagination-item--active`,
                    clickable: true,
                },
                on: {
                    breakpoint: function (swiper, breakpointParams) {
                        $slider.toggleClass('_controls-off', breakpointParams.slidesPerView === slidesCount);
                        $slider.parent().toggleClass('_controls-off-wrap', breakpointParams.slidesPerView === slidesCount);
                    },
                }
            };

            new Swiper(this, options);
            //
            // if (slidesCount > 1 && (slidesPerView == 'auto' || slidesPerView < slidesCount)) {
            //
            // } else {
            //     $slider.parent().addClass('_controls-off');
            // }
        });
    });
}

function getSlidesPerView(options) {
    if (options.breakpoints) {
        let breakpoints = Object.keys(options.breakpoints).sort((a, b) => {if (+a > +b) return -1; if (+a == +b) return 0; if (+a < +b) return 1;});

        for (let i = 0; i < breakpoints.length; i++) {
            if (window.innerWidth > breakpoints[i]) return options.breakpoints[breakpoints[i]].slidesPerView || 1;
        }
    }
    return options.slidesPerView || 1;
}
